module.exports = __webpack_public_path__ + "static/media/cards.e02707ef.jpg";